function f(t, n, e) {
  return t === n ? !0 : e ? e.some((r) => t.startsWith(r)) : !1;
}
function i(t, n) {
  for (const e of n) {
    if (e.href && f(t, e.href, e.matchPatterns))
      return e.key;
    for (const r of e.children ?? [])
      if (f(t, r.href, r.matchPatterns))
        return e.key;
  }
  return null;
}
export {
  i as findActiveSectionKey,
  f as isRouteActive
};
